export enum AddParticipantConst {
  ADD_PARTICIPANT = 'ADD:PARTICIPANT',
  ADD_PARTICIPANT_OK = 'ADD:PARTICIPANT:OK',
  ADD_PARTICIPANT_KO = 'ADD:PARTICIPANT:KO',
}
